import { render, staticRenderFns } from "./ArchitectsList.vue?vue&type=template&id=30fc4107"
import script from "./ArchitectsList.vue?vue&type=script&lang=js"
export * from "./ArchitectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports